// extracted by mini-css-extract-plugin
export default {"layout":"Selected_layout__6aUoH"};